export default __webpack_public_path__ + "media/music/f0656a016774478fd04b5df04d0a8d93.mp3";